const toArray = <T>(items: T | T[]) => (Array.isArray(items) ? items : [items]);
export default toArray;
